// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__PlayerContext from "./playerContext.jsx";
import * as StoreFx__UpdatePlayQueue from "./updatePlayQueue.jsx";
import * as Throttle from "../throttle/throttle.jsx";

function run(store) {
  const fx = Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const state = param.store.getState();
    const match = state.player.currentSongId;
    if (match !== undefined) {
      return StoreFx__UpdatePlayQueue.make(function (prevState) {
        return {
          current: prevState.current,
          currentTime: Math.floor(StoreFx__PlayerContext.audio.currentTime * 1000.0),
          queued: prevState.queued
        };
      });
    } else {
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }
  }));
  return Fx.runAsync(fx, {
    store: store
  }).then(function (result) {
    return Promise.resolve(Stdlib__Result.get_ok(result));
  });
}

const include = Throttle.Make({
  ms: 5000,
  run: run
});

const timeout = include.timeout;

const make = include.make;

const now = include.now;

export {
  timeout,
  make,
  now,
}
/* include Not a pure module */
